var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;

var ProductDiv = React.createClass({

  prodUrl: "",
  
  componentDidMount: function(){
    setTimeout(function(){ jQuery(window).scroll(); }, 300);
  },

  getInitialState: function() {
    var collection = this.props.collection ? this.props.collection : "";

    if (!collection) {
      var prodType = this.props.product.product_type;

      if (prodType.indexOf('CASUAL') >= 0) {
        collection = 'casual-shoes';
      } else if (prodType.indexOf('BOOT') >= 0) {
        collection = 'boots';
      } else if (prodType.indexOf('SANDAL') >= 0) {
        collection = 'sandals';
      } else if (prodType.indexOf('DRESS') >= 0) {
        collection = 'dress-shoes';
      } else {
        collection = 'specialty-shoes';
      }
    }

    return { gender: this.getGender(),
             collection: collection }
  },

  getGender: function() {
    return this.props.product.tags.indexOf("Womens") >= 0 ? "womens" : "mens";
  },

  render: function() {

    this.prodUrl = "/products/" + this.props.product.handle;
    var imgSrc = this.props.product.images[0] ? 
                 (this.props.product.images[0].src ? this.props.product.images[0].src : this.props.product.images[0])
                 : ImageUrl.dummyShoe;
    return <div className={"col-sm-4 product-thumb" + (this.props.noFade ? "" : " fade-in")}
                id={this.props.product.handle}>
        <Link to={this.prodUrl}>
            <div>
                <img src={imgSrc}></img>
            </div>
            <p className="shoe-name">{this.props.product.title}</p>
        </Link>
      </div>
  }
});

module.exports = React.createClass({

  getInitialState: function() {
    var prodDivs = this.props.products ? this.createProductDivs(this.props.products) : [];

  	return { productDivs: prodDivs }
  },

  createProductDivs: function(products) {
  	return products.map(function(prod) {
  		return <ProductDiv collection={this.props.collection}
                         product={prod}
                         noFade={this.props.noFade}
                         forBrand={this.props.forBrand}
                         key={prod.handle}/>
  	}.bind(this));
  },

  setProducts: function(products) {
    products = _.take(products, 3);
  	this.setState({productDivs: this.createProductDivs(products)});
  },

  render: function() {

  	return <div className="row product-row">
        {this.state.productDivs}
  	  </div>
  }
});
